/* Setup Layout Part - Theme Panel */
angular.module('quantixApp').controller('ThemePanelController',
		ThemePanelController);
ThemePanelController.$inject = [ '$scope','$http', '$q'];
function ThemePanelController($scope,$http, $q) {
	
			 $scope.css = 'color-default';
			 $scope.selectedColor='default';
			 $scope.themeArr = [  
			                      { name: 'default', classU: 'color-default  tooltips', title:'Default'},  
			                      { name: 'darkblue', classU: 'color-darkblue  tooltips', title:'Dark Blue'},  
			                      { name: 'blue', classU: 'color-blue  tooltips', title:'Blue'}, 
			                      { name: 'grey', classU: 'color-grey  tooltips', title:'Grey'},
			                      { name: 'light', classU: 'color-light  tooltips', title:'Light'}  
			                    ]; 
			 $scope.value='fluid';
			 $scope.layout=[{'val':'fluid'},
			                {'val':'boxed'}];
			 $scope.header='fixed';
			 $scope.headerVal=[{'val':'fixed'},
			                {'val':'default'}];
			 $scope.topMenu='light';
			 $scope.topMenuVal=[{'val':'light'},
				                {'val':'dark'}];
			 $scope.sidebar='left';
			 $scope.sidebarVal=[{'val':'left'},
				                {'val':'right'}];
			 $scope.footer='fixed';
			 $scope.footerVal=[{'val':'fixed'},
				                {'val':'default'}];
			$scope.$on('$includeContentLoaded', function() {
				Demo.init(); // init theme panel 
				handleSidebarAndContentHeight();

			});
			
			$scope.setColors = function(object){
				$scope.selectedColor = object.name;
				setColor(object.name);
				
			}
			
			 var setColor = function(color) {
		            var color_ = (App.isRTL() ? color + '-rtl' : color);
		            $('#style_color').attr("href", 'content/css/metronic/css/' + color_ + ".min.css");
		            if (color == 'light2') {
		                $('.page-logo img').attr('src', 'content/images/' + 'logo-invert.png');
		            } else {
		                $('.page-logo img').attr('src', 'content/images/' + 'logo.png');
		            }
		        };
//		        $scope.headervalue='';
		        $scope.saveTheme = function(){
		        	alert(JSON.stringify($scope.header));
		        	var searchText = {
		    				'color' : $scope.selectedColor,
		    				'layout' : $scope.value,
		    				'header' : $scope.header,
		    				'topMenu' : $scope.topMenu,
		    				'sidebar' : $scope.sidebar,
		    				'footer' : $scope.footer
		    			}
		        	var deferred = $q.defer();
					var url = 'api/theme/savetheme';

					$http.post(url, searchText).then(function(response) {
						deferred.resolve(response.data);
					}, function(errResponse) {
						deferred.reject(errResponse);
					});
					return deferred.promise;
//		        	alert(JSON.stringify(searchText));
//		        	var deferred = $q.defer();
//					var url = 'api/theme/savetheme';
//					$http.post(url, {searchText} ,{ignoreLoadingBar: true }).then(function(response) {
//						deferred.resolve(response);
//
//					}, function(errResponse) {
//						deferred.reject(errResponse);
//					});
//
//					return deferred.promise;
		        	
		        }
		}

//Set proper height for sidebar and content. The content and sidebar height must be synced always.